import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/c54a7b7/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ComponentReact = makeShortcode("ComponentReact");
const ComponentDocs = makeShortcode("ComponentDocs");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <ComponentReact name="Dropdown" component="Dropdown" variation="Dropdown" hasVanillaVersion hasAngularVersion hasVueVersion mdxType="ComponentReact"></ComponentReact>
    <ComponentReact name="Dropdown inline" component="Dropdown" variation="Dropdown.Inline" hasVanillaVersion hasVueVersion mdxType="ComponentReact"></ComponentReact>
    <ComponentReact name="Multi select" component="MultiSelect" variation="MultiSelect" hasAngularVersion hasVueVersion mdxType="ComponentReact"></ComponentReact>
    <ComponentReact name="Filterable multi select" component="MultiSelect" variation="MultiSelect.Filterable" hasAngularVersion hasVueVersion mdxType="ComponentReact"></ComponentReact>
    <ComponentReact name="Inline multi select" component="MultiSelect" variation="MultiSelect.Inline" hasAngularVersion hasVueVersion mdxType="ComponentReact"></ComponentReact>
    <ComponentReact name="Combo box" component="ComboBox" hasAngularVersion hasVueVersion mdxType="ComponentReact"></ComponentReact>
    <h2 {...{
      "id": "documentation"
    }}>{`Documentation`}</h2>
    <ComponentDocs component="dropdown" mdxType="ComponentDocs" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      